import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateBrand } from "../../api/apiBrands";
import parseError from "../../utils/parseError";

/**
 * Hook لتحديث علامة تجارية موجودة
 */
export function useUpdateBrand() {
    const queryClient = useQueryClient();

    const {
        mutate: editBrand,
        isPending: isUpdate,
    } = useMutation({
        mutationFn: ({ id, brandData }) => updateBrand(id, brandData),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["brands"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update brand");
        },
    });

    return {
        editBrand,
        isUpdate,
    };
}
